import { BreakPoints, Button, Flex, IconButton, useBreakpoint } from '@cellula/react';

interface Props {
	onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
	text: string;
}

export function StepBack({ onClick, text }: Props): JSX.Element {
	const isMobile = useBreakpoint(BreakPoints.Small);

	return (
		<Flex shrink={0}>
			{isMobile ? (
				<IconButton variant='interactive' icon='arrowLeft' size='small' text={text} onClick={onClick} />
			) : (
				<Button variant='ghost' size='xSmall' icon='arrowLeft' onClick={onClick}>
					{text}
				</Button>
			)}
		</Flex>
	);
}
